import { put, takeEvery, select } from 'redux-saga/effects';
import { userSelector } from '../../../redux/selectors';
import { isUserAccessAllowed } from '../../../utils/general-functions';
import { openModal } from './actions';
import {
  challengeIndexForSuperBlockSelector,
  challengeMetaSelector,
  completedChallengesIdsSelector,
  isBuildEnabledSelector
} from './selectors';

function* verifyNotAllowedChallenge({ payload }) {
  try {
    const isBuildEnabled = yield select(isBuildEnabledSelector);
    if (!isBuildEnabled) {
      return;
    }

    const user = yield select(userSelector);
    const completedChallengeIds = yield select(completedChallengesIdsSelector);
    const challengeMeta = yield select(challengeMetaSelector);
    const challengeIndexForSuperBlock = yield select(
      challengeIndexForSuperBlockSelector
    );

    const isAllowed = yield isUserAccessAllowed({
      challengeMeta,
      completedChallengeIds,
      challenge: payload,
      user,
      challengeIndexForSuperBlock
    });

    if (!isAllowed) {
      yield put(openModal('notAllowedChallenge'));
    }
  } catch (e) {
    console.log(e);
  }
}

export function createIsAllowedChallnge(types) {
  return [takeEvery(types.isAllowedChallenge, verifyNotAllowedChallenge)];
}
